import { lazy } from 'react';

export const LoginPage = lazy(() => import('../components/Pages/LoginPage'));

export const HomePage = lazy(() => import('../components/Pages/HomePage'));

export const NotFoundPage = lazy(() => import('../components/Pages/NotFoundPage'));

export const UserPage = lazy(() => import('../components/Pages/UsersPage'));

export const InternalUserPage = lazy(() => import('../components/Pages/InternalUsersPage'));